module.exports = __webpack_public_path__ + "img/palacio.eed40ca5.jpg";